export const extensions = {
    document: {
        navigation: 'x-scalar-navigation',
    },
    workspace: {
        colorMode: 'x-scalar-color-mode',
        sidebarWidth: 'x-scalar-sidebar-width',
        defaultClient: 'x-scalar-default-client',
        defaultExample: 'x-scalar-default-example',
        activeDocument: 'x-scalar-active-document',
        theme: 'x-scalar-theme',
    },
};
